var notificationMixin = {
    created: function () {
        if ("Notification" in window) {
            this.hasPermission = Notification["permission"] === "granted";
            if (!this.hasPermission) {
                this.requestPermission();
            }
        }
    },
    data: function () {
        return {
            hasPermission: null
        };
    },
    methods: {
        requestPermission: function () {
            var _this = this;
            Notification.requestPermission()
                .then(function (permission) {
                _this.hasPermission = permission === "granted";
            });
        },
        // TODO: make icon dynamic to store
        triggerNotification: function (title, msg, icon) {
            if (icon === void 0) { icon = ""; }
            if (this.hasPermission) {
                new Notification(title, {
                    body: msg,
                    icon: icon
                });
            }
        }
    }
};
export default notificationMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/notificationMixin.ts
// module id = 9xmh
// module chunks = 18